import { sendGet, sendPost } from './axios';

export const getProfileAgent = (id) => sendGet(`/agent/${id}`);

export const getLikeToTarget = (id) => sendGet(`/like/${id}`);

export const getCardList = ({ id, filter }) => sendPost(`/agent/list-profile/${id}?pageIndex=${filter.pageIndex}&pageSize=${filter.pageSize}`);

export const createLike = (payload) => sendPost(`/like`, payload);

export const getConversationToTarget = (targetId) => sendGet(`/conversation/user/${targetId}`);

export const createConversation = (targetId) => sendPost(`/conversation/user/${targetId}`);

export const createBlock = (payload) => sendPost(`/block`, payload);

export const createReport = (payload) => sendPost(`/report`, payload);
